import PropTypes from 'prop-types';
import React from 'react';

import {Logo} from '../../shared/components/Logo';
import {NavMenu} from '../NavMenu';
import './HomeHeader.style.scss';

export const HomeHeader = (props) => {
  return (
    <header className="home-header">
      <div className="home-header__content">
        <div className="home-header__logo">
          <Logo />
        </div>
        <NavMenu {...props} />
      </div>
    </header>
  );
};

HomeHeader.propTypes = {
  buttonFunctionShowAccreditation: PropTypes.func
};
